import React from "react";
import "./About.css";

export default function CurrentProjects() {
  return (
    <>
    <br />
      <p>
        For enquires and commissions, please contact Niamh’s agent <a href="https://aitkenalexander.co.uk/literary-agents/harriet-moore">Harriet Moore</a> at <a href="mailto:harriet@aitkenalexander.co.uk">harriet@aitkenalexander.co.uk</a>, or you can reach Niamh directly at <a href="mailto:niamhgordonwrites@gmail.com">niamhgordonwrites@gmail.com</a>.
      </p>
      <p>
        Substack: <a href="niamhgordon.substack.com">niamhgordon.substack.com</a>
      </p>
      <p>
        Insta: <a href="http://instagram.com/_niamhgordon/">@_niamhgordon</a>
      </p>
    </>
  );
}
